"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Help = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./Help.pc.css");
const Help = ({ className, nofilter, testId, icon, content, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_af09cf08', '_9ac55765', '_pub-9ac55765', '_pub-3c25d522', {
            '_9ac55765_nofilter _pub-9ac55765_nofilter _pub-3c25d522_nofilter nofilter': nofilter,
        }, className), "data-testid": testId },
        icon && (react_1.default.createElement("div", { className: (0, clsx_1.default)('_14fd198d', '_9ac55765', '_pub-9ac55765', '_pub-3c25d522') }, icon)),
        content || children));
};
exports.Help = Help;
//# sourceMappingURL=Help.js.map